import React from 'react';
import { Link } from 'react-router-dom';

const Footer: React.FC = () => {
  return (
    <footer className="pb-6">
      <div className="mx-auto w-full max-w-6xl px-4 sm:px-6">
        <div className="glass-panel rounded-[28px] p-6 transition duration-300 hover:border-white/20 hover:bg-white/10">
          <div className="grid gap-8 md:grid-cols-[1.1fr_0.9fr]">
            <div>
              <p className="font-display text-lg font-semibold tracking-tight text-white">Vizo</p>
              <p className="mt-3 max-w-xl text-sm leading-7 text-slate-400">
                Create modern music visuals, export cleaner videos, and manage support and privacy from one place.
              </p>
              <div className="mt-4 flex flex-wrap gap-3 text-xs text-slate-400">
                <span className="rounded-full bg-slate-950/40 px-3 py-2">iPhone</span>
                <span className="rounded-full bg-slate-950/40 px-3 py-2">iOS 17.0+</span>
                <span className="rounded-full bg-slate-950/40 px-3 py-2">Premium visual tools</span>
                <span className="rounded-full bg-slate-950/40 px-3 py-2">Clean export workflow</span>
              </div>
            </div>
            <div className="flex flex-wrap items-center gap-4 text-sm text-slate-300">
              <Link to="/" className="transition hover:text-white">Home</Link>
              <Link to="/support" className="transition hover:text-white">Support</Link>
              <Link to="/privacy" className="transition hover:text-white">Privacy</Link>
              <a
                href="https://www.apple.com/legal/internet-services/itunes/dev/stdeula/"
                target="_blank"
                rel="noopener noreferrer"
                className="transition hover:text-white"
              >
                Terms
              </a>
              <a
                href="https://apps.apple.com/tr/app/unvis-music-visualizer/id6749325448"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center rounded-full border border-white/10 bg-slate-950/40 px-4 py-2 text-white transition hover:border-white/20 hover:bg-white/10"
              >
                App Store
              </a>
            </div>
          </div>
          <div className="mt-6 flex flex-wrap items-center justify-between gap-3 border-t border-white/10 pt-5 text-sm text-slate-400">
            <p>2018 - 2026 Vizo</p>
            <p>Built for iPhone users who want music, motion, and clean exports.</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
